import { render, staticRenderFns } from "./RestaurantEdit.vue?vue&type=template&id=df398776&"
import script from "./RestaurantEdit.vue?vue&type=script&lang=js&"
export * from "./RestaurantEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports